import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, FileCheck, Calculator, ShieldCheck, Building2, UserCheck, Check } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  FileCheck,
  Calculator,
  ShieldCheck,
  Building2,
  UserCheck
};

const Services = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <main className="pt-20 bg-white">
      {/* Hero com imagem aérea de Manaus/Zona Franca ao fundo */}
      <section className="relative section-spacing overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1611516491426-03025e6043c8?w=1920&q=80" 
            alt="Vista aérea de Manaus"
            className="w-full h-full object-cover"
          />
          {/* Overlay claro para legibilidade */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#F7FAFC]/95 via-[#F7FAFC]/90 to-[#F7FAFC]/70" />
        </div>
        <div className="container-main relative z-10">
          <div className="max-w-3xl">
            <span className="caption mb-4 block">Nossos Serviços</span>
            <h1 className="heading-display mb-6">
              Soluções sob medida para cada desafio
            </h1>
            <p className="body-large">
              Oferecemos serviços especializados em auditoria, consultoria tributária, 
              governança corporativa e terceirização de processos. Cada solução é desenvolvida 
              para atender às necessidades específicas do seu negócio.
            </p>
          </div>
        </div>
      </section>

      {/* Services Detail */}
      <section>
        {services.map((service, index) => {
          const IconComponent = iconMap[service.icon];
          const isEven = index % 2 === 0;
          
          return (
            <div 
              key={service.id} 
              id={service.slug}
              className={`section-spacing ${isEven ? 'bg-white' : 'bg-[#F7FAFC]'}`}
            >
              <div className="container-main">
                <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start`}>
                  {/* Content */}
                  <div className={!isEven ? 'lg:order-2' : ''}>
                    <div className="w-14 h-14 bg-[#E7F2E3] rounded-xl flex items-center justify-center mb-6">
                      {IconComponent && <IconComponent size={28} className="text-[#3E6B2A]" />}
                    </div>
                    <h2 className="heading-2 mb-4">{service.title}</h2>
                    <p className="body-large mb-8">{service.fullDescription}</p>
                    
                    {/* Features List */}
                    <ul className="space-y-3 mb-8">
                      {service.features.map((feature, i) => (
                        <li key={i} className="flex items-start gap-3">
                          <div className="w-5 h-5 rounded-full bg-[#E7F2E3] flex items-center justify-center flex-shrink-0 mt-0.5">
                            <Check size={12} className="text-[#3E6B2A]" />
                          </div>
                          <span className="text-[#475569]">{feature}</span>
                        </li>
                      ))}
                    </ul>

                    <Link to="/contato" className="btn-primary">
                      Solicitar Proposta
                      <ArrowRight size={18} />
                    </Link>
                  </div>

                  {/* Info Card */}
                  <div className={`${!isEven ? 'lg:order-1' : ''}`}>
                    <div className="bg-white border border-[#E2E8F0] rounded-lg p-8 shadow-sm">
                      <div className="mb-8">
                        <h3 className="text-[#3E6B2A] font-semibold mb-3">Para quem é</h3>
                        <p className="text-[#64748B]">{service.forWho}</p>
                      </div>
                      <div className="pt-8 border-t border-[#E2E8F0]">
                        <h3 className="text-[#3E6B2A] font-semibold mb-3">Resultados esperados</h3>
                        <p className="text-[#64748B]">{service.results}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </section>

      {/* CTA - Card claro em vez de faixa verde */}
      <section className="section-spacing bg-white">
        <div className="container-main">
          <div className="bg-[#F7FAFC] border border-[#E2E8F0] rounded-lg p-12 text-center">
            <h2 className="heading-2 text-[#0F172A] mb-4">Não encontrou o que procura?</h2>
            <p className="body-medium mb-8 max-w-2xl mx-auto">
              Entre em contato conosco e descreva sua necessidade. 
              Teremos prazer em desenvolver uma solução personalizada para você.
            </p>
            <Link to="/contato" className="btn-primary">
              Fale com um Especialista
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Services;
